import { Component, Vue } from 'vue-property-decorator'
import CACG1110ViewModel from './CACG1110ViewModel'
import CACG1110Service from './CACG1110Service'
import CACG1120ParamModel from '../CACG1120/CACG1120ParamModel'
import CACG1130ParamModel from '../CACG1130/CACG1130ParamModel'
import { FormatConstants } from '@/common/FormatConstants'
import TransportService from '@/common/TransportService'
import CommonConstants from '@/common/CommonConstants'
import ShowMore from '@/assets/js/components/show-more.js'
import CommonUtil from '@/common/utils/CommonUtil'
import 'simplebar'
import 'simplebar/dist/simplebar.css'
import { fixedContent } from '@/assets/js/main.js'
import { nextTick } from 'process'

@Component({
  name: 'CACG1110',
  components: {}
  })
export default class CACG1110Controller extends Vue {
  private isCompleteLoading = false
  private CommonUtil = CommonUtil
  private FormatConstants = FormatConstants
  private CommonConstants = CommonConstants
  private cacg1110ViewModel: CACG1110ViewModel = {
    productNameInformal: '',
    productDivName: '',
    productDiv2: '',
    productNo: '',
    shhnCd: '',
    depositRateInfo: {
      depositRateStartDate: '',
      depositRateEndDate: '',
      rate: null,
      wowRate: null
    },

    investTrustProductLast10YearDataLst: [
      {
        refYearMonth: '',
        creditingRate: null
      }
    ],
    creditingRateInfo: {
      creditingRateCritMonth: '',
      thisMonthCreditingRate: null,
      everyMonthCreditingRate: null
    }
  }

  private cacg1110Service = new CACG1110Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    nextTick(() => {
      fixedContent()
    })

    this.clickExpandOrFoldMore()
  }

  /**
   * 初期処理
   */
  private async init() {
    const productNo = JSON.parse(
      JSON.stringify(this.$route.query.productNo || '')
    )
    const shhnCd = JSON.parse(JSON.stringify(this.$route.query.shhnCd || ''))

    this.cacg1110ViewModel.productNo = productNo
    this.cacg1110ViewModel.shhnCd = shhnCd
    const params = `shhnCd=${this.cacg1110ViewModel.shhnCd}`
    const [
      caca1060ResponseModel,
      transportResponseModel
    ] = await Promise.all([
      this.cacg1110Service.callAPICACA1110(
        productNo,
        shhnCd
      ),
      // 稼働／閲覧統計ログを実行する
      TransportService.callAPITransportWithLogMode(CommonConstants.URL_CACG1110, null, params, CommonConstants.LOG_MODE_ACCESS_ONLY)
    ])

    this.cacg1110ViewModel.productDivName =
      caca1060ResponseModel?.productDivName
    this.cacg1110ViewModel.productNameInformal =
      caca1060ResponseModel?.productNameInformal
    this.cacg1110ViewModel.productDiv2 = caca1060ResponseModel?.productDiv2

    this.cacg1110ViewModel.depositRateInfo = CommonUtil.isNotEmpty(
      caca1060ResponseModel.depositRateInfo
    )
      ? caca1060ResponseModel.depositRateInfo
      : null

    this.cacg1110ViewModel.investTrustProductLast10YearDataLst =
      CommonUtil.isNotEmpty(
        caca1060ResponseModel.investTrustProductLast10YearDataLst
      )
        ? caca1060ResponseModel.investTrustProductLast10YearDataLst
        : null

    this.cacg1110ViewModel.creditingRateInfo = CommonUtil.isNotEmpty(
      caca1060ResponseModel.creditingRateInfo
    )
      ? caca1060ResponseModel.creditingRateInfo
      : null

    this.isCompleteLoading = true
  }

  /**
   * もっと見るの展開・折畳
   */
  private clickExpandOrFoldMore() {
    if (
      this.cacg1110ViewModel.investTrustProductLast10YearDataLst?.length > 12
    ) {
      ShowMore()
    }
  }

  /**
   * 資料タブ切り替え
   */
  private gotoCACG1120() {
    const productNoParam: CACG1120ParamModel['productNo'] =
      this.cacg1110ViewModel.productNo
    const shhnCdPram: CACG1120ParamModel['shhnCd'] =
      this.cacg1110ViewModel.shhnCd
    this.$router.push({
      name: 'cacg1120',
      query: {
        productNo: productNoParam,
        shhnCd: shhnCdPram
      }
    })
  }

  /**
   * チャートタブ切り替え
   */
  private gotoCACG1130() {
    const productNoParam: CACG1130ParamModel['productNo'] =
      this.cacg1110ViewModel.productNo
    const shhnCdPram: CACG1130ParamModel['shhnCd'] =
      this.cacg1110ViewModel.shhnCd
    this.$router.push({
      name: 'cacg1130',
      query: {
        productNo: productNoParam,
        shhnCd: shhnCdPram
      }
    })
  }

  /**
   * 運用商品ラインアップに戻るリンク押下
   */
  private gotoCACG1010() {
    this.$router.push({ name: 'cacg1010' })
  }
}
